import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import OrderHelpIntro from '../../components/OrderHelpIntro';

import { RESOLUTION_SELECTION } from '../OrderHelpTemplateContainer/templateTypes';

export function OrderHelpIntroContainer({ contentHeader, contentText, isHeartStyleIntro }) {
  if (!contentHeader && !contentText) {
    return null;
  }

  return (
    <Spacer spacing={`${isHeartStyleIntro ? 'medium large' : ''}`}>
      <OrderHelpIntro
        contentHeader={contentHeader}
        contentText={contentText}
        isHeartStyleIntro={isHeartStyleIntro}
      />
    </Spacer>
  );
}

OrderHelpIntroContainer.defaultProps = {
  contentHeader: '',
  contentText: '',
  isHeartStyleIntro: false,
};

OrderHelpIntroContainer.propTypes = {
  /**
   * The header for the content within the self help page
   */
  contentHeader: PropTypes.string,
  /**
   * The text for the content within the self help page
   */
  contentText: PropTypes.string,
  /**
   * Whether to show the heart style seen for RESOLUTION_SELECTION templates
   */
  isHeartStyleIntro: PropTypes.bool,
};

const mapStateToProps = ({ order }) => ({
  contentHeader: order.help.header,
  contentText: order.help.data && order.help.data.text,
  isHeartStyleIntro: order.help.type === RESOLUTION_SELECTION,
});

export default connect(mapStateToProps)(OrderHelpIntroContainer);
